export default class Service {
    static get $inject() {
        return [
            '$rootScope', '$q', '$timeout', 'ApiRemoteService'];
    }

    constructor($rootScope, $q, $timeout,
                ApiRemoteService) {

        this._$q = $q;
        this._$timeout = $timeout;
        this._$rootScope = $rootScope;

        this._ApiRemoteService = ApiRemoteService;

    }

    // Generic Command
    _run(fnc, panelId) {
        let deferred = this._$q.defer();
        fnc.bind(this._ApiRemoteService)(panelId)
            .then(v => {
                deferred.resolve(v)
            })
            .catch(err => {
                deferred.reject(err);
            });
        return deferred.promise;
    }


    // --- Actions -----------------------------------------------------------------------------------------------------


    // General
    setPanicAlarm(panelId) {
        return this._run(this._ApiRemoteService.setPanicAlarm, panelId);
    }

    getPanicAlarmState(panelId) {
        return this._run(this._ApiRemoteService.getPanicAlarmState, panelId);
    }

    resetGeneralAlarms(panelId) {
        return this._run(this._ApiRemoteService.resetGeneralAlarms, panelId);
    }

    //users
    getUsers(panelId) {
        return this._ApiRemoteService.getUsers(panelId);
    }

    //troubles
    getTroubles(panelId) {

        let deferred = this._$q.defer();

        this._ApiRemoteService.getTroubles(panelId)
            .then(v => {

                deferred.resolve(v);

            })
            .catch(err => {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    // Areas
    setArea(panelId, areaId, state, force) {

        let deferred = this._$q.defer();

        this._ApiRemoteService.setArea(panelId, areaId, state, force)
            .then(v => {

                deferred.resolve(v);

            })
            .catch(err => {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    getAreasConfigList(panelId) {

        let deferred = this._$q.defer();

        this._ApiRemoteService.getAreasConfigList(panelId)
            .then((r) => {

                deferred.resolve(r.data);

            })
            .catch(err => {

                deferred.reject(err);

            });

        return deferred.promise;

    }

    // Zones
    getLatestDectHomeAutomationMeasurements(panelId) {

        return this._ApiRemoteService.getLatestDectHomeAutomationMeasurements(panelId);
    }

    getLatestByZoneDectHomeAutomationMeasurements(panelId) {

        return this._ApiRemoteService.getLatestByZoneDectHomeAutomationMeasurements(panelId);
    }

    getZonesConfigList(panelId) {

        let deferred = this._$q.defer();

        this._ApiRemoteService.getZonesConfigList(panelId)
            .then((r) => {
                deferred.resolve(r.data);
            })
            .catch(err => {
                deferred.reject(err);
            });

        return deferred.promise;

    }

    setZoneBypass(panelId, zoneId, bypass) {

        let deferred = this._$q.defer();

        this._ApiRemoteService.setZoneBypass(panelId, zoneId, bypass)
            .then((r) => {
                deferred.resolve(r.data);
            })
            .catch(err => {
                deferred.reject(err);
            });

        return deferred.promise;

    }

    // Outputs
    getOutputsConfigList(panelId) {

        let deferred = this._$q.defer();

        this._ApiRemoteService.getOutputsConfigList(panelId)
            .then((r) => {

                deferred.resolve(r.data);

            })
            .catch(err => {

                deferred.reject(err);

            });

        return deferred.promise;

    }

    setOutput(panelId, outputId, state) {

        let deferred = this._$q.defer();

        this._ApiRemoteService.setOutput(panelId, outputId, state)
            .then((r) => {

                deferred.resolve(r.data);

            })
            .catch(err => {

                deferred.reject(err);

            });

        return deferred.promise;

    }

    // Doorlocks

    getDoorLocksConfigList(panelId) {
        return this._ApiRemoteService.getDoorLocksConfigList(panelId);
    }

    setDoorLock(panelId, doorLockId, state) {
        return this._ApiRemoteService.setDoorLock(panelId, doorLockId, state);
    }

    // Keypads
    getKeypadsConfigList(panelId) {
        let deferred = this._$q.defer();
        this._ApiRemoteService.getKeypadsConfigList(panelId).then((r) => {

                deferred.resolve(r.data);

            })
            .catch(err => {

                deferred.reject(err);

            });

        return deferred.promise;
    }

}



/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/services/remote.service.js
 **/